import {
    SET_RAN_CONTENT,
    NEXT_ITEM_ACTIVE_INDEX,
    RESET_ITEM_ACTIVE_INDEX,
    CLEAR_ITEM_ACTIVE_INDEX,
    ADD_RAN_SELECTED_RESPONSE,
    RESET_RAN_SELECTED_RESPONSES,
    SET_TIME_DURATION,
} from './ranActions';

export const defaultState = {
    isDataFetched: false,
    practice: [],
    items: [],
    activeItemIndex: 0,
    selectedResponses: [],
    timeDuration: undefined,
};

const mapItemsContent = item => ({
    itemId: item.item_id,
    stimulus: {
        text: item.stimulus.text,
        image: item.stimulus.image,
    },
});

const reformatRANContent = apiContent => ({
    assessment: apiContent.assessment,
    measure: apiContent.measure,
    formId: apiContent.form_id,
    practice: apiContent.practice.map(mapItemsContent),
    items: apiContent.items.map(mapItemsContent),
});

const ranReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_RAN_CONTENT:
            return {
                ...state,
                isDataFetched: true,
                ...reformatRANContent(action.content),
            };
        case NEXT_ITEM_ACTIVE_INDEX:
            return {
                ...state,
                activeItemIndex: state.activeItemIndex + 1,
            };
        case RESET_ITEM_ACTIVE_INDEX:
            return {
                ...state,
                activeItemIndex: 0,
            };
        case CLEAR_ITEM_ACTIVE_INDEX:
            return {
                ...state,
                activeItemIndex: undefined,
            };
        case ADD_RAN_SELECTED_RESPONSE:
            return {
                ...state,
                selectedResponses: [...state.selectedResponses, action.response],
            };
        case RESET_RAN_SELECTED_RESPONSES:
            return {
                ...state,
                selectedResponses: [],
            };
        case SET_TIME_DURATION:
            return {
                ...state,
                timeDuration: action.timeDuration,
            };
        default:
            return state;
    }
};

export default ranReducer;
